import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../../../../core/services/notification/notification.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TransactionResult } from '../../../../../core/services/interfaces/transaction-result';
import { IEmployees } from '../../Interfaces/IEmployees';
import { ISites } from '../../Interfaces/ISites';
import { EmployeesService } from '../../services/employees-service';
import { TranslateService } from '../../../../../core/services/translate-service';
import { IEmployeesInActiveDirectory } from '../../Interfaces/IEmployeesInActiveDirectory';
import { TranslateApplicationService } from '../../../../../core/translate/translate-application-service';
import { ActiveDirectoryService } from '../../services/activedirectory-services';
import { SitesService } from '../../services/sites-services';
import { IRoles } from '../../Interfaces/IRoles';
import { RolesService } from '../../services/roles-service';
import { IApproversAreas } from '../../Interfaces/IApproversAreas';
import { ApproversAreasService } from '../../services/approversAreas-service';
import { IEmployeesApproversAreas } from '../../Interfaces/IEmployeesApproersAreas';
import { IBuildings } from '../../Interfaces/IBuildings';
import { BuildingsService } from '../../services/buildings-services';
declare var jQuery: any;

interface Building {
    label: string;
    value: {
        building: string;
        pkbuilding: number;
    };
}
interface BuildingValues {
    building: string;
    pkbuilding: number;
}
interface ApproverAreas {
    label: string;
    value: {
        approverarea: string;
        pkapproverarea: number;
    };
}
interface ApproverAreaValues {
    approverarea: string;
    pkapproverarea: number;
}
@Component({
    selector: 'employee-detail',
    templateUrl: './employees-detail.component.html',
    styleUrls: ['employees-detail.component.scss'],
})
export class EmployeesDetailComponent {
    formGroup: FormGroup;
    listSites: Array<ISites> = [];
    listRoles: Array<IRoles> = [];
    listApproversAreas: Array<IApproversAreas> = [];
    selectedApproversAreas: Array<IApproversAreas> = [];
    listApproversAreasNG: ApproverAreas[] = [];
    listSitesBuildingEmployee: Array<ISites> = [];
    listSitesBuildingUsername: Array<ISites> = [];
    listBuildings: Array<IBuildings> = [];
    selectedBuildings: Array<IBuildings> = [];
    listBuildingsNG: Building[] = [];
    loading = false;
    requieredApproversAreas = false;
    i: number;
    thereIsBuilding: boolean;
    toChange: Array<number> = [];
    toChangeParents: Array<number> = [];
    value: boolean;
    searching: boolean = false;
    searched: boolean = false;
    showInpEmployeeSerch: boolean = false;
   
    constructor(
        private dialogRef: MatDialogRef<EmployeesDetailComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IEmployees,
        private notificationService: NotificationService,
        private translateService: TranslateService,
        private activeDirectoryService: ActiveDirectoryService,
        private employeeService: EmployeesService,
        private siteService: SitesService,
        private formBuilder: FormBuilder,
        private rolesService: RolesService,
        private approversAreasService: ApproversAreasService,
        public translate: TranslateApplicationService,
        private buildingsService: BuildingsService,
    ) {
        this.formGroup = this.formBuilder.group({
            pkemployee: [data.pkemployee == null ? 0 : data.pkemployee],
            txtemployeename: [data.employeename, Validators.required],
            txtemail: [data.email == null ? '' : data.email],
            txtworkdayid: [data.workdayid, Validators.required],
            txtemployeenumber: [
                data.employeenumber == null ? 0 : data.employeenumber,
                Validators.required,
            ],
            txtposition: [data.position == null ? '' : data.position],
            cbfkrole: [data.fkrole, Validators.required],
            cbapproversarea: [''],
            fksite: [data.fksite],
            txtusername: [
                data.username == null ? '' : data.username,
                Validators.required,
            ],
            cbbuildings: ['', Validators.required],
        });
    }
    ngOnInit() {
        this.loading = true;
        jQuery('.cdk-overlay-pane').css('overflow', 'scroll');
        const component = this;
        jQuery('#inpEmployeeSerch').selectpicker();
        jQuery('.bs-searchbox').find('input').keyup(function () {
            if (jQuery(this).val().length >= 4 && !component.searching && !component.searched
            ) {
                component.searching = true;
                jQuery('#inpEmployeeSerch').empty();
                jQuery('#inpEmployeeSerch').selectpicker('refresh');
                component.GetEmployeeByEmailNumberName(jQuery(this).val());
            }
            if (jQuery(this).val().length < 4) 
                component.searched = false;
        });
        jQuery('#inpEmployeeSerch').change(function () {
            component.GetEmployeeByDistinguishedname(
                jQuery('#inpEmployeeSerch').val(),
            );
        });
        this.GetRoles();
        this.GetApproversAreas();
        this.GetBuildings();
        this.GetApproversAreasByUsername();
        if (this.formGroup.controls.pkemployee.value != 0) {
            this.GetBuildingsByUsername();
            this.showInpEmployeeSerch = true;
        }
    }

    Alert() {
        this.notificationService.AddAlert({
            icon: 'all_inbox',
            title: 'Success',
            message: this.translate.TranslateKey('COMPLETE'),
            shown: true,
        });
    }

    ChangeRole() {
        setTimeout(() => {
            let role = jQuery('#cbRole').find('span.ng-value-label.ng-star-inserted').text();
            if (role == 'Approver') {
                this.requieredApproversAreas = true;
            } 
            else {
                this.requieredApproversAreas = false;
            }
        }, 200);
    }

    Close() {
        this.dialogRef.close(true);
    }

    ChangeEmployeeSearch(event) {
		jQuery('.p-dropdown').css('max-width', '300px');
		this.GetEmployeeByDistinguishedname(
			event.value.distinguishedname.toString()
		);
	}

    CreateEmployee() {
        this.loading = true;
        this.employeeService.SetEmployeeRoleSite(this.formGroup.value).subscribe(
        (result: TransactionResult<boolean>) => {
            if (result.success) {
                // Change the value from available to true was selected
                this.listBuildings.forEach((element) => {
                    for (let x = 0; x < this.formGroup.controls.cbbuildings.value.length; x++) {
                        if (this.formGroup.controls.cbbuildings.value[x].pkbuilding == element.pkbuilding) {
                            element.available = true;
                            break;
                        }
                    }
                });
                let areasLength = this.formGroup.controls.cbapproversarea.value.length;
                if (areasLength > 0) {
                    // Change the value from available to true was selected
                    this.listApproversAreas.forEach((element) => {
                        for (let x = 0; x < areasLength; x++) {
                            if ( this.formGroup.controls.cbapproversarea.value[x].pkapproverarea == element.pkapproverarea) {
                                element.available = true;
                                break;
                            }
                        }
                    });
                    // Save employee buildings
                    this.listBuildings.forEach((building) => {
                        this.employeeService.SetEmployeeBuilding(this.formGroup.controls.pkemployee.value, this.formGroup.controls.txtusername.value, building).subscribe(
                        (result: TransactionResult<boolean>) => {
                            if (result.success) {
                                this.listApproversAreas.forEach((approverarea) => {
                                    this.employeeService.SetEmployeeApproverArea(this.formGroup.value,building,approverarea).subscribe(
                                    (result: TransactionResult<boolean>,) => {
                                        if (result.success) {

                                        }
                                    },
                                    (error) => {
                                        this.ErrorAlert(error);
                                        this.loading = false;
                                    });
                                });
                            }
                            else{
                                this.ErrorAlert(result.message);
                                this.loading = false;
                            }
                        },
                        (error: any) => {
                            this.ErrorAlert(error);
                            this.loading = false;
                        });
                    });
                } 
                else {
                // Save employee buildings
                    this.listBuildings.forEach((building) => {
                        this.employeeService.SetEmployeeBuilding(this.formGroup.controls.pkemployee.value,this.formGroup.controls.txtusername.value,building).subscribe(
                        (result: TransactionResult<boolean>) => {
                            if (result.success) {
                                let isApprover = this.listRoles.filter((element) => element.pkrole == this.formGroup.controls.cbfkrole.value)[0];
                                if(isApprover.role.toLocaleLowerCase().trim() != "ehs administrator" &&
                                isApprover.role.toLocaleLowerCase().trim() != "it administrator" &&
                                isApprover.role.toLocaleLowerCase().trim() != "operation manager") {
                                    this.listApproversAreas.forEach((approverarea) => {
                                        this.employeeService.SetEmployeeApproverArea(this.formGroup.value,building,approverarea).subscribe(
                                        (result: TransactionResult<boolean>,) => {
                                            if (result.success) {

                                            }
                                            else{
                                                this.ErrorAlert(result.message);
                                                this.loading = false;
                                            }
                                        },
                                        (error) => {
                                            this.ErrorAlert(error);
                                            this.loading = false;
                                        });
                                    });
                                }
                                else{
                                    this.loading = false;
                                }
                            } 
                        },
                        (error: any) => {
                            this.ErrorAlert(error);
                            this.loading = false;
                        });
                    });
                }
            }
        });
        this.Close();
    }
    GetApproversAreas() {
        this.loading = true;
        this.approversAreasService.GetList().subscribe(
        (result: TransactionResult<IApproversAreas[]>) => {
            this.loading = false;
            if (result.success) {
                result.data.forEach((obj) => {
                    /*
                    List to save the approver areas of the employee that have been selected.
                    Set the available value to 'false' and then change it to 'true' if the area was selected
                    */
                    obj.available = false;
                    this.listApproversAreas.push(obj);
                    // List to use the 'p-multiselect' component to display the list of approver areas
                    this.listApproversAreasNG.push({
                        label: obj.approverarea,
                        value: {
                            approverarea: obj.approverarea,
                            pkapproverarea: obj.pkapproverarea,
                        },
                    });
                });
            }
            else{
                this.ErrorAlert(result.message);
            }
        },
        (error: any) => {
            this.ErrorAlert(error);
            this.loading = false;
        });
    }

    GetApproversAreasByUsername() {
        if(this.data.role.toLocaleLowerCase() == 'approver'){
            this.employeeService.GetEmployeesApproversAreas(this.formGroup.controls.pkemployee.value).subscribe(
            (result: TransactionResult<IApproversAreas[]>) => {
                if (result.success) {
                    if (result.data.length > 0) {
                        this.requieredApproversAreas = true;
                        let areas: ApproverAreaValues[] = [];
                        result.data.forEach((element) => {
                            let approverarea: ApproverAreaValues = {
                                approverarea: element.approverarea,
                                pkapproverarea: element.pkapproverarea,
                            };
                            areas.push(approverarea);
                        });
                        this.formGroup.controls.cbapproversarea.setValue(areas);
                        this.loading = false;
                    }
                }
                else{
                    this.ErrorAlert(result.message);
                this.loading = false;

                }
            },
            (error: any) => {
                this.ErrorAlert(error);
                this.loading = false;
            });
        } 
        else{
            this.requieredApproversAreas = false; 
        }
    }

    GetBuildings() {
        this.loading = true;
        this.buildingsService.GetBuildingsBySite().subscribe(
        (result: TransactionResult<IBuildings[]>) => {
            if (result.success) {
                this.loading = false;
                result.data.forEach((obj) => {
                    if(obj.available == true){
                        obj.available = false;
                        this.listBuildings.push(obj);
                        // List to use the 'p-multiselect' component to display the list of buildings
                        this.listBuildingsNG.push({
                            label: obj.building,
                            value: {
                                building: obj.building,
                                pkbuilding: obj.pkbuilding,
                            },
                        });
                    }
                    /*
                    List to save the buildings of the employee that have been selected.
                    Set the available value to 'false' and then change it to 'true' if the building was selected
                    */
                });
                /* // preparar la lista de edificios para guardar los selecciondos
                this.listBuildings.forEach((element) => {
                element.available = false;
                }); */
            }
            else{
                this.ErrorAlert(result.message);
                this.loading = false;
            }
        },
        (error: any) => {
            this.ErrorAlert(error);
            this.loading = false;
        });
    }

    GetBuildingsByUsername() {
        this.loading = true;
        this.employeeService.GetBuildingsByUser(this.formGroup.value).subscribe(
        (result: TransactionResult<IBuildings[]>) => {
            if (result.success) {
                this.loading = false;
                let buildings: BuildingValues[] = [];
                // Retrieve the buildings and add to the formGroup
                result.data.forEach((element) => {
                    if (element.available) {
                        let building: BuildingValues = {
                            pkbuilding: element.pkbuilding,
                            building: element.building,
                        };
                        buildings.push(building);
                    }
                });
                this.formGroup.controls.cbbuildings.setValue(buildings);
            }
            else{
                this.ErrorAlert(result.message);
                this.loading = false;
            }
        },
        (error: any) => {
            this.ErrorAlert(error);
            this.loading = false;
        });
    }

    GetEmployeeByEmailNumberName(value: string) {
		this.loading = true;
		var arr: IEmployeesInActiveDirectory[] = [];
		this.activeDirectoryService.GetEmployeeByEmailNumberName(value).subscribe(
        (result: TransactionResult<IEmployeesInActiveDirectory[]>) => {
            this.loading = false;
            this.searching = false;
            this.searched = true;
            if (result.success) {
                var jsonObj = JSON.parse(result.data.toString());
                arr = jsonObj.data;
                jsonObj.data.name;
                arr.forEach((obj) => {
                    jQuery('#inpEmployeeSerch').append(
                        '<option value="' +
                            obj.distinguishedname +
                            '">' +
                            obj.name +
                            '</option >',
                    );
                });
                jQuery('#inpEmployeeSerch').selectpicker('refresh');
                jQuery('#inpEmployeeSerch').change();
            }
            else{
                this.ErrorAlert(result.message);
            }
        },
        (error: any) => {
            this.ErrorAlert(error);
            this.loading = false;
        });
	}

    GetEmployeeByDistinguishedname(value: string) {
        this.loading = true;
        var arr: IEmployeesInActiveDirectory[] = [];
        this.activeDirectoryService.GetEmployeeByDistinguishedname(value).subscribe(
        (result: TransactionResult<IEmployeesInActiveDirectory[]>) => {
            this.loading = false;
            if (result.success) {
                var jsonObj = JSON.parse(result.data.toString());
                arr = jsonObj.data;
                this.formGroup.controls.txtemployeename.setValue(arr[0].name);
                this.formGroup.controls.txtusername.setValue(arr[0].userName);
                this.formGroup.controls.txtworkdayid.setValue(arr[0].workdayId);
                this.formGroup.controls.txtemployeenumber.setValue(arr[0].employeeNumber);
                if (arr[0].email != null) {
                    this.formGroup.controls.txtemail.setValue(arr[0].email);
                }
                this.formGroup.controls.txtposition.setValue(arr[0].position);
            }
            else{
                this.ErrorAlert(result.message);
            }
        },
        (error: any) => {
            this.ErrorAlert(error);
            this.loading = false;
        });
    }
    GetRoles() {
        this.loading = true;
        this.rolesService.GetRolesBySite().subscribe(
        (result: TransactionResult<IRoles[]>) => {
            this.loading = false;
            if (result.success) {
                if (this.formGroup.controls.pkemployee.value == 0) {
                    this.rolesService.GetRoleByUser().subscribe(
                        (resultRol: TransactionResult<IRoles>) => {
                            if(resultRol){
                                if(resultRol['role'] == "Administrator"){
                                    this.listRoles = result.data.filter((element) => element.available == true);
                                }else{
                                    this.listRoles = result.data.filter((element) => element.available == true && element.role != "Administrator");
                                }
                            }	
                        }
                    );
                }else{
                    this.rolesService.GetRoleByUser().subscribe(
                        (resultRol: TransactionResult<IRoles>) => {
                            if(resultRol){
                                if(resultRol['role'] == "Administrator"){
                                    this.listRoles = result.data.filter((element) => element.available == true);
                                }else{
                                    if(this.data.role.toLowerCase().trim() == "Administrator".toLowerCase().trim()){
                                        this.listRoles = result.data.filter((element) => element.available == true);
                                    }else{
                                        this.listRoles = result.data.filter((element) => element.available == true && element.role != "Administrator");
                                    }
                                }
                            }	
                        }
                    );
                }                
            }
            else{
                this.ErrorAlert(result.message);
            }
        },
        (error: any) => {
            this.ErrorAlert(error);
            this.loading = false;
        });
    }

    Save() {
        this.loading = true;
        if(this.formGroup.valid){
            if (this.formGroup.controls.pkemployee.value == 0) {
                this.Create();
            } else {
                if(this.data.role.toLowerCase().trim() == "Administrator".toLowerCase().trim()){
                    this.rolesService.GetRoleByUser().subscribe(
                        (resultRol: TransactionResult<IRoles>) => {
                            if(resultRol){
                                if( resultRol['role'].toLowerCase().trim() == "Administrator".toLowerCase().trim()){
                                    this.Update();
                                }else{
                                    this.loading = false;
                                    this.notificationService.AddAlert({
                                        icon: 'all_inbox',
                                        title: 'Warning',
                                        message: this.translate.TranslateKey('WARNINGS.Empty_fields'),
                                        shown: true,
                                    });
                                }
                            }
                        }
                    );
                }else{
                    this.Update();
                }                
            }
        } 
        else {
            this.loading = false;
            this.notificationService.AddAlert({
                icon: 'all_inbox',
                title: 'Warning',
                message: this.translate.TranslateKey('WARNINGS.Empty_fields'),
                shown: true,
            });
        }
    }

    Create(){
        this.employeeService.GetEmployeeByUserName(this.formGroup.controls.txtusername.value).subscribe(
        (result1: TransactionResult<IEmployees[]>) => {
            if (result1.success) {
                if (result1.data.length > 0) {
                    this.employeeService.GetEmployeeByUserNameAndSite(this.formGroup.controls.txtworkdayid.value).subscribe(
                    (result: TransactionResult<IEmployees[]>) => {
                        if (result.data.length > 0) {
                        this.notificationService.AddAlert({
                            icon: 'all_inbox',
                            title: 'Error',
                            message: this.translate.TranslateKey('EMPLOYEES.DUPLICATE_EMPLOYEE'),
                            shown: true,
                        });
                        this.loading = false;
                        } 
                        else {
                            this.UpdateEmployee();
                            this.Alert();
                        }
                    },
                    (error) => {
                        this.ErrorAlert(error);
                        this.loading = false;
                    });
                } 
                else {
                    this.employeeService.CreateEmployee(this.formGroup.value).subscribe(
                    (result: TransactionResult<boolean>) => {
                        this.loading = false;
                        if (result.success) {
                            this.loading = true;
                            this.CreateEmployee();
                            this.Alert();
                        }
                        else {
                            this.ErrorAlert(result.message);
                            this.loading = false;
                        }
                    },
                    (error) => {
                        this.ErrorAlert(error);
                        this.loading = false;
                    });
                }
            }
            else 
            {
                this.ErrorAlert(result1.message);
                this.loading = false;
            }
        },
        (error) => {
          this.ErrorAlert(error);
          this.loading = false;
        });
    }

    Update(){
        var arr: IEmployeesInActiveDirectory[] = [];
        var arr1: IEmployeesInActiveDirectory[] = [];
        this.employeeService.GetEmployeeByUserNameAndSite(this.formGroup.controls.txtworkdayid.value).subscribe(
        (result: TransactionResult<IEmployees[]>) => {
            if (result.success){
                result.data;
                this.activeDirectoryService.GetEmployeeByEmailNumberName(result.data[0].username).subscribe(
                (result1: TransactionResult<IEmployeesInActiveDirectory[]>) => {
                    this.loading = false;
                    if (result1.success) {
                        var jsonObj = JSON.parse(result1.data.toString());
                        arr1 = jsonObj.data;
                        jsonObj.data.name;
                        arr1.forEach((obj) => {
                            this.activeDirectoryService.GetEmployeeByDistinguishedname(obj.distinguishedname).subscribe(
                            (result2: TransactionResult<IEmployeesInActiveDirectory[]>) => {
                                this.loading = false;
                                if (result2.success) {
                                    var jsonObj = JSON.parse(result2.data.toString());
                                    arr = jsonObj.data;
                                    this.formGroup.controls.txtemployeename.setValue(arr[0].name);
                                    this.formGroup.controls.txtusername.setValue(arr[0].userName);
                                    this.formGroup.controls.txtworkdayid.setValue(arr[0].workdayId);
                                    this.formGroup.controls.txtemployeenumber.setValue(arr[0].employeeNumber);
                                    if (arr[0].email != null) {
                                        this.formGroup.controls.txtemail.setValue(arr[0].email);
                                    }
                                    this.formGroup.controls.txtposition.setValue(arr[0].position);
                                    this.employeeService.UpdateEmployee(this.formGroup.value).subscribe(
                                    (result: TransactionResult<boolean>) => {
                                        this.loading = false;
                                        if (result.success) {
                                            this.loading = true;
                                            this.UpdateEmployee();
                                            this.Alert();
                                        }
                                        else{
                                            this.ErrorAlert(result.message);
                                        }
                                    },
                                    (error) => {
                                        this.ErrorAlert(error);
                                        this.loading = false;
                                    });
                                }
                                else{
                                    this.ErrorAlert(result2.message);
                                    this.loading = false;
                                }
                            },
                            (error: any) => {
                                this.ErrorAlert(error);
                                this.loading = false;
                            });
                        });
                    }
                    else{
                        this.ErrorAlert(result1.message);
                        this.loading = false;
                    }
                },
                (error) => {
                    this.ErrorAlert(error);
                    this.loading = false;
                });
            }
            else{
                this.ErrorAlert(result.message);
                this.loading = false;
            }
        },
        (error) => {
            this.ErrorAlert(error);
            this.loading = false;
        });
    }

    UpdateEmployee() {
        this.loading = true;
        this.employeeService.SetEmployeeRoleSite(this.formGroup.value).subscribe(
        (result: TransactionResult<boolean>) => {
            if (result.success) {
                // Change the value from available to true was selected
                this.listBuildings.forEach((element) => {
                    for (let x = 0;x <this.formGroup.controls.cbbuildings.value.length;x++) {
                        if (this.formGroup.controls.cbbuildings.value[x].pkbuilding == element.pkbuilding) {
                            element.available = true;
                            break;
                        }
                    }
                });
                let areasLength = this.formGroup.controls.cbapproversarea.value.length;
                let isApprover = this.listRoles.filter((element) => element.pkrole == this.formGroup.controls.cbfkrole.value)[0];
                if (areasLength > 0 && isApprover.role.toLocaleLowerCase().trim() == "approver") {
                // Change the value from available to true was selected
                this.listApproversAreas.forEach((element) => {
                    for (let x = 0; x < areasLength; x++) {
                        if (this.formGroup.controls.cbapproversarea.value[x].pkapproverarea == element.pkapproverarea) {
                            element.available = true;
                            break;
                        }
                    }
                });
                // Save employee buildings
                this.listBuildings.forEach((building) => {
                    this.employeeService.SetEmployeeBuilding(this.formGroup.controls.pkemployee.value,this.formGroup.controls.txtusername.value,building).subscribe(
                    (result: TransactionResult<boolean>) => {
                        if (result.success) {
                            this.listApproversAreas.forEach((approverarea) => {
                                this.employeeService.SetEmployeeApproverArea(this.formGroup.value,building,approverarea,).subscribe(
                                (result: TransactionResult<boolean>) => {
                                    if (result.success) {
                                        this.Close();
                                    }
                                    else {
                                        this.ErrorAlert(result.message);
                                        this.loading = false;
                                    }
                                },
                                (error) => {
                                    this.ErrorAlert(error);
                                    this.loading = false;
                                });
                            });
                        }
                        else {
                            this.ErrorAlert(result.message);
                            this.loading = false;
                        }
                    },
                    (error: any) => {
                        this.ErrorAlert(error);
                        this.loading = false;
                    });
                });
                this.Close();
                } 
                else if (areasLength == 0 && isApprover.role.toLocaleLowerCase().trim() == "approver") {
                    this.loading = false;
                    this.notificationService.AddAlert({
                        icon: 'all_inbox',
                        title: 'Warning',
                        message: this.translate.TranslateKey('WARNINGS.Empty_fields'),
                        shown: true,
                    });
                } 
                else {
                    // Save employee buildings
                    this.listBuildings.forEach((building) => {
                        this.employeeService.SetEmployeeBuilding(this.formGroup.controls.pkemployee.value,this.formGroup.controls.txtusername.value,building).subscribe(
                        (result: TransactionResult<boolean>) => {
                            if (result.success) {
                                if (isApprover.role.toLocaleLowerCase().trim() != "ehs administrator" &&
                                isApprover.role.toLocaleLowerCase().trim() != "it administrator" &&
                                isApprover.role.toLocaleLowerCase().trim() != "operation manager"
                                ) {
                                    this.listApproversAreas.forEach((approverarea) => {
                                        this.employeeService.SetEmployeeApproverArea(this.formGroup.value,building,approverarea,).subscribe(
                                        (result: TransactionResult<boolean>) => {
                                            if (result.success) {
                                                this.Close();
                                            }
                                            else {
                                                this.ErrorAlert(result.message);
                                                this.loading = false;
                                            }
                                        },
                                        (error) => {
                                            this.ErrorAlert(error);
                                            this.loading = false;
                                        });
                                    });
                                }
                                else {
                                    this.loading = false;
                                    this.Close();
                                }
                            }
                            else{
                                this.ErrorAlert(result.message);
                                this.loading = false;
                            }
                        },
                        (error: any) => {
                            this.ErrorAlert(error);
                            this.loading = false;
                        });
                    });
                }
            }
        },
        (error)=>{
            this.ErrorAlert(error);
            this.loading = false;
        });
        //this.Close();
    }
    
    ErrorAlert(message: any) {
        this.notificationService.AddAlert({
            icon: 'all_inbox',
            title: 'Error',
            message: message,
            shown: true,
        });
    }
}